<template>
  <div class="testoRiepilogo row">
    <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-3 nomeTyp">{{wine.nomeTyp}}</div>
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-5 nomeVino">{{wine.nome}}</div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-4 quantity"><input type="number"
                                                                           name="quantity"
                                                                           min="0" max="999"
                                                                           class="quantità" id="qua"
                                                                           oninput="validity.valid||(value=1)"
                                                                           v-model="qntyProd" @blur="changeQnty">
    </div>
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 disponibilita">
      <date-picker v-model="available" lang="it" format="DD-MM-YYYY" @change="setAvailability"></date-picker>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 price1" v-price>{{wine.price}}</div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "singlewinemanager",
    data() {
      return {
        qntyProd: 0,
        available: ''
      }
    },
    props: {
      wine: {type: Object}
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          prod_add: 'Operazione avvenuta con successo',
          prb_prod_add: 'Errore'
        },
        en: {
          prod_add: 'Operazione avvenuta con successo',
          prb_prod_add: 'Errore'
        }
      }
    },
    mounted: function () {
      this.qntyProd = this.wine.qntyProd
      this.available = this.wine.available
    },
    methods: {
      setAvailability: function () {
        this.$http.put('/ws-admin/manage/product/' + this.wine.id + '/available', {avblDate: moment(this.available).format('YYYY-MM-DD')}, {emulateJSON: true}).then(response => {
          if (response.body.rc === 0) {
            this.$toasted.show(this.$t('prod_add'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'success',
              duration: 4000
            })
          } else {
            this.$toasted.show(this.$t('prb_prod_add'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'error',
              duration: 4000
            })
          }
        })
      },
      changeQnty: function () {
        this.$http.put('/ws-admin/manage/product/' + this.wine.id + '/qnty', {qnty: this.qntyProd}, {emulateJSON: true}).then(response => {
          if (response.body.rc === 0) {
            this.$toasted.show(this.$t('prod_add'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'success',
              duration: 4000
            })
          } else {
            this.$toasted.show(this.$t('prb_prod_add'), {
              theme: 'primary',
              position: 'bottom-right',
              type: 'error',
              duration: 4000
            })
          }
        })
      }
    }
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/SingleWineManager.vue